// import { Dcoptions, Pieoptions, WorkAssign } from "../../../Helper/Data"
import React, { useEffect, useState } from 'react'
import { Loading } from '../../../Helper/Loading'
import Header from '../../../Components/Header/Header'
import Sidebar from '../../../Components/Sidebar/Sidebar'
import GardenMaintainanceCardManage from './GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceCardManage'
import WaterMasterCardManage from './WaterSupplyDashboardComponent/WaterMasterCard/WaterMasterCardManage'
import PreventiveWaterQualityCardManage from './WaterSupplyDashboardComponent/WaterPreventiveQualityCard/PreventiveWaterQualityCardManage'
import WaterPreventiveWorkCardManage from './WaterSupplyDashboardComponent/WaterPreventiveWorkCard/WaterPreventiveWorkCardManage'
import WaterAssignMainWorkCardManage from './WaterSupplyDashboardComponent/WaterAssignedMaintainanceWorkCard/WaterAssignMainWorkCardManage'
import WaterPreMainWorkCardManage from './WaterSupplyDashboardComponent/WaterPreventiveMaintainanceWorkCard/WaterPreMainWorkCardManage'
import { useAuthState } from '../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { DistribuionCountAPI, WTPDashboardCountAPI } from '../../../Redux/DashboardCountSlice/DashboardCountSlice'
import CommonDashboardWardNameDDL from './CommonDashboardWardNameDDL'
import WTPMasterCardManage from './WTPDashboardComponent/WTPMasterCard/WTPMasterCardManage'
import WTPDataUploadCardManage from './WTPDashboardComponent/WTPDataUPload/WTPDataUploadCardManage'
import { WTPDashboard } from './WTPDashboard'
import { OfficialVisitTabel, OfficialVisitTable } from './WaterSupplyDashboardComponent/OfficialVisitAddTable/OfficialVisitTable'
import GardenMaintainanceComp from './GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceComp'
import TTPPreventiveworkCard from './WaterSupplyDashboardComponent/TTPPreventivework/TTPPreventiveworkCard'

export const WaterSupplyDashboard = () => {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    const [DashProjectTypeId, setDashProjectTypeId] = useState(sessionStorage.getItem("FJ853K") ? sessionStorage.getItem("FJ853K") : (M_ProjectTypeID != 0 ? M_ProjectTypeID : RoleID == 2 ? '5' : '6'))

    // M_ProjectTypeID == '0' ? '6' : M_ProjectTypeID == "0" ? "7" : M_ProjectTypeID
    // console.log('M_ProjectTypeID' , ProjectTypeId)

    useEffect(() => {
        sessionStorage.setItem("FJ853K", DashProjectTypeId)
    }, [DashProjectTypeId])

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select Ward",
    })
    const [Countdata, setCountdata] = useState({})
    const [MasterCountData, setMasterCountData] = useState({})
    const [WTPMasterCountData, setWTPMasterCountData] = useState({})

    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ActiveClass, setActiveClass] = useState('Distribution')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }

        {
            (DashProjectTypeId != 0 && Ward.ID != 0 && Month.ID != 0 && year.ID != 0) &&
                dispatch(DistribuionCountAPI({ data }))
        }

    }, [Ward.ID, Month.ID, year.ID, DashProjectTypeId])

    useEffect(() => {
        // console.log(DashProjectTypeId)
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetMasterCount,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }

        {
            (DashProjectTypeId != 0 && Ward.ID != 0 && Month.ID != 0 && year.ID != 0) &&
                dispatch(DistribuionCountAPI({ data }))
        }

    }, [DashProjectTypeId, Ward.ID, Month.ID, year.ID])

    const { CountData, isLoading } = useSelector(state => state.DistribuionCountData)

    useEffect(() => {
        // console.log(DashProjectTypeId)
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetWTPMasterCount,
        }
        if (year.ID != 0 && Ward.ID != 0 && Month.ID != 0) {
            dispatch(WTPDashboardCountAPI({ data }))
        }
    }, [DashProjectTypeId, Ward.ID, Month.ID, year.ID])

    const { WTPCountData, isWTPLoading } = useSelector(state => state.WTPDashboardCountData)

    const handleGetCount = (data) => {

        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    const handleGetMasterCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setMasterCountData(tempData)
    }

    const handleGetWTPMasterCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setWTPMasterCountData(tempData)
    }

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="main-content side_shrink position-relative border-radius-lg "></div> */}
            <div>

                <Header
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                    Name="Water Supply"
                />
                {/* <Sidebar active="dashboard" /> */}
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        // active="gardenn"
                        listActive="gardennn" />

                    <div className="content1 content">


                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                        />

                        {
                            RoleID == '1' &&
                            <GardenMaintainanceComp />
                        }
                        {/* <div className="mb-4 m-1 py-2 px-3 master_border" style={{ borderRadius: "15px" }}>
                            <GardenMaintainanceCardManage />
                        </div> */}
                        {
                            (M_ProjectTypeID == '0') &&
                            <div className='row bg-white m-0 p-0  master_border mb-3'>
                                <div className='col-lg-12 col-12 tabws mb-md-2 pe-lg-2'>

                                    <div className="btn-group float-end mt-2" role="group" aria-label="Basic outlined example" style={{ border: '1px solid #001313', borderRadius: '5px' }}>
                                        {
                                            RoleID == 2 &&
                                            <button
                                                onClick={() => setDashProjectTypeId("5")}
                                                className={DashProjectTypeId === "5" ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                                type="button">
                                                Official Visit
                                            </button>
                                        }

                                        <button
                                            onClick={() => setDashProjectTypeId("6")}
                                            className={DashProjectTypeId === "6" ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                            style={{ borderLeft: '1px solid #001313', borderRight: '1px solid #001313' }}
                                            type="button">
                                            Distribution Line
                                        </button>
                                        <button
                                            onClick={() => setDashProjectTypeId("9")}
                                            className={DashProjectTypeId === "9" ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                            style={{ borderLeft: '1px solid #001313', borderRight: '1px solid #001313' }}
                                            type="button">
                                            T T P
                                        </button>
                                        <button
                                            onClick={() => setDashProjectTypeId("1")}
                                            className={DashProjectTypeId === "1" ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                            style={{ borderLeft: '1px solid #001313', borderRight: '1px solid #001313' }}
                                            type="button">
                                            Main Feeder
                                        </button>
                                        <button
                                            onClick={() => setDashProjectTypeId("7")}
                                            className={DashProjectTypeId === "7" ? "btn px-4 activebutton text-white" : "text-black btn px-4"}
                                            type="button">
                                            WTP Dashboard
                                        </button>
                                    </div>
                                </div>
                            </div>

                        }

                        {/* {
                            ActiveClass === "6" ? */}

                        {DashProjectTypeId == "7" ?
                            <WTPDashboard
                                DashProjectTypeId={DashProjectTypeId}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                                WTPMasterCountData={WTPMasterCountData}
                            />

                            : (DashProjectTypeId == "5") ?
                                <OfficialVisitTable
                                    FinancialYear={FinancialYear?.ID}
                                    Month={Month?.ID}
                                    M_WardID={WardValue}
                                    AssetID='0' />
                                : (DashProjectTypeId == "9") ?   // TTP
                                    <>
                                        <div className="m-1 py-2 pb-4 master_border">
                                            <WaterMasterCardManage  // Master card component for TTP
                                                // Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                                MasterCountData={MasterCountData}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-0 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 pt-1 pb-2">Preventive Water Quality</h5>
                                            </div>
                                            <PreventiveWaterQualityCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 pt-1 pb-2">Preventive Work</h5>
                                            </div>
                                            <TTPPreventiveworkCard
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12 mb-2 pt-1">
                                                <h5 className="ps-2">Preventive Maintainance Work</h5>
                                            </div>
                                            <WaterPreMainWorkCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId} />

                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 py-2 ">Assigned Maintainance Work</h5>
                                            </div>
                                            <WaterAssignMainWorkCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId} />

                                        </div>

                                    </>
                                    :
                                    <>
                                        <div className="m-1 py-2 pb-4 master_border">
                                            <WaterMasterCardManage
                                                // Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                                MasterCountData={MasterCountData}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-0 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 pt-1 pb-2">Preventive Water Quality</h5>
                                            </div>
                                            <PreventiveWaterQualityCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 pt-1 pb-2">Preventive Work</h5>
                                            </div>
                                            <WaterPreventiveWorkCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId}
                                            />
                                        </div>

                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12 mb-2 pt-1">
                                                <h5 className="ps-2">Preventive Maintainance Work</h5>
                                            </div>
                                            <WaterPreMainWorkCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId} />

                                        </div>
                                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                                            <div className="col-12">
                                                <h5 className="ps-2 py-2 ">Assigned Maintainance Work</h5>
                                            </div>
                                            <WaterAssignMainWorkCardManage
                                                Countdata={Countdata}
                                                YearValue={YearValue}
                                                YearLabel={YearLabel}
                                                MonthValue={MonthValue}
                                                MonthLabel={MonthLabel}
                                                WardValue={WardValue}
                                                WardLabel={WardLabel}
                                                ProjectTypeId={ProjectTypeId}
                                                DashboardName={DashboardName}
                                                DashProjectTypeId={DashProjectTypeId} />

                                        </div>
                                    </>
                        }


                    </div>
                    {/* <!-- [ Main Content ] end --> */}
                </div>
            </div>
        </>
    )
}
